// Story 10.4 — Bar chart de mensajes recibidos por hora del día (0-23).

import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { AnalyticsHour } from '@/lib/analytics-types';

interface Props {
  data: AnalyticsHour[];
}

export function HourlyHeatmap({ data }: Props): React.ReactElement {
  const peak = data.reduce((acc, b) => (b.count > acc ? b.count : acc), 0);
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Horarios pico</CardTitle>
      </CardHeader>
      <CardContent>
        <div
          className="h-[220px] w-full"
          role="img"
          aria-label="Distribución horaria de mensajes recibidos (0-23h)"
        >
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: -16 }}>
              <CartesianGrid stroke="var(--border)" strokeDasharray="3 3" vertical={false} />
              <XAxis
                dataKey="hour"
                stroke="var(--muted-foreground)"
                tick={{ fontSize: 11 }}
                tickFormatter={(h: number) => `${h}h`}
              />
              <YAxis stroke="var(--muted-foreground)" tick={{ fontSize: 11 }} />
              <Tooltip
                contentStyle={{
                  background: 'var(--card)',
                  border: '1px solid var(--border)',
                  fontSize: 12,
                }}
                formatter={(value: number) => [`${value} mensajes`, 'Recibidos']}
                labelFormatter={(h) => `${h}:00 – ${(Number(h) + 1) % 24}:00`}
              />
              <Bar dataKey="count" name="Mensajes" radius={[2, 2, 0, 0]}>
                {data.map((d) => (
                  <Cell
                    key={d.hour}
                    fill={d.count === peak && peak > 0 ? 'var(--primary)' : 'var(--primary)'}
                    fillOpacity={d.count === peak && peak > 0 ? 1 : 0.55}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
